class Lookups {
  static MEDICATION_TYPE = "MedicationTypes";
  static ALLERGY_TYPE = "AllergyTypes";
  static ALLERGY_CATEGORY = "AllergyCategories";
  static ALLERGY_STATUS = "AllergyStatuses";
  static CONDITION_CATEGORY = "ConditionCategories";
  static ETHNICITY_CATEGORY = "EthnicityCategories";
  static PHONE_TYPE = "PhoneTypes";
  static GENDER_OPTIONS = "Genders";
  static LABTEST_CATEGORY = "LabTestCategories";
  static LANGUAGE_OPTIONS = "LanguageOptions";
  static RACE_CATEGORY = "RaceCategories";
  static SEVERITY_LEVEL = "SeverityLevels";
  static INSURANCE_TYPE = "InsuranceTypes";
  static ASSESSMENTSCORE_TYPE = "AssessmentScoreTypes";
  static CONTACT_TYPE = "ContactTypes";
  static TASK_PRIORITY = "TaskPriorities";
  // static APPOINTMENT_CATEGORY = "AppointmentCategories";
  static NOTIFICATION_TYPE = "NotificationTypes";
  static SPECIALITY = "ProviderSpecialties";
  static MEDICATION_STATUS = "MedicationStatuses";
  static MEDICATION_RECONCILIATION_STATUS = "MedicationReconciliationStatuses";
  static CONDITION_RECONCILIATION_STATUS = "ConditionReconciliationStatuses";
  static CONDITION_STATUS = "ConditionStatuses";
  static PROGRAM_TYPES = "Programs";
  static CARE_PLAN_REJECTION_TYPES = "CarePlanRejectionTypes";
}

export default Lookups;

export class Workflow {
  static APPOINTMENT_STATUS_CANCELED = "Canceled";
  static APPOINTMENT_STATUS_COMPLETED = "Completed";
  static APPOINTMENT_STATUS_NO_SHOW = "No Show";
  static APPOINTMENT_STATUS_PLANNED = "Planned";
  static APPOINTMENT_STATUS_RESCHEDULED = "Rescheduled";
  static APPOINTMENT_STATUS_INPROGRESS = "In-Progress";
}

export class Constants {
  static VIDEO_MODE = "Video Call";
  static TELEPHONE_MODE = "Telephone";
  static NOT_SET = "Not Set";
  static NULL = "Null";
  // static ADMIN = "Admin"
  // static SUPERVISOR = "Supervisor"
  // static CLINICAL_LIAISON = "Clinical Liaison"
  // static SUPPORT = "Support"
  static PROGRAM_DISCHARGE = "Program Discharge";
  static PROGRAM_END_EXCLUSION = "Program End - Exclusion";
  static PROGRAM_END_WITHDRAWL = "Program End - Withdrawal";
  static NEW_PATIENT = "New Patient";
  static DONE_STATUS = "Done";
  static TASK_TYPE_SUPPLY_ORDER = "Supply Order";
  static UPCOMING_APPTS = "Upcoming Appts";
  static NO_UPCOMING_APPTS = "No upcoming Appts";
  static COACH_ME = "me";
  static UPCOMING_APPTS_FILTER_KEY = "UPCOMING_APPTS_FILTER_KEY";
  static COACH_FILTER_KEY = "COACH_FILTER_KEY";
  static APP_ONE_ONE = "APP_ONE_ONE";
  static PROGRAM_FILTER_KEY = "PROGRAM_FILTER_KEY";
  static ALL = "all";
  static DEFAULT = "default";
  static PRIORITY_LOW = "Low";
}

export class CommandCenterConstants {
  static EPISODE_TYPE_EMERGENT = "Emergent";
  static EPISODE_TYPE_URGENT = "Urgent";
  static EPISODE_TYPE_NON_URGENT = "Non-Urgent";
  static EPISODE_TYPE_NON_URGENT_ID = "6b42df70-e032-4f82-abba-3df99df4dc7e";
  static EPISODE_STATUS_NEW_NEEDS_ACTION_ID =
    "fd83b816-20f4-4335-91d1-eafa45301858";
  static COMMAND_CENTER = "Command Center";
  static ALERT_HISTORY_CREATED_BY = "Created by";
  static ALERT_HISTORY_ALERT_CATEGORY = "Alert category";
  static ALERT_HISTORY_TYPE = "Type";
  static ALERT_HISTORY_STATUS = "Status";
  static ALERT_HISTORY_START_DATE = "Start date";
  static ALERT_HISTORY_END_DATE = "End date";
  static ALERT_HISTORY_ASSIGNEE = "Assignee";
  static ALERT_HISTORY_PROBLEM = "Problem";
  static ALERT_HISTORY_FOLLOW_UP = "Follow Up";
  static ALERT_HISTORY_UTILIZATION_AVOIDED = "Utilization avoided";
  // episode statuses (name + rollup)
  static EPISODE_STATUS_NEEDS_ACTION_NEW = "Needs Action New";
  static EPISODE_STATUS_EXTERNAL_PENDING = "External Pending";
  static EPISODE_STATUS_INTERNAL_PENDING = "Internal Pending";
  static EPISODE_STATUS_INTERNAL_CLOSED = "Internal Closed";
  static EPISODE_STATUS_EXTERNAL_CLOSED = "External Closed";
  static EPISODE_STATUS_OTHER_CLOSED = "Other (Closed) Closed";
  static EPISODE_STATUS_MISSING_INFORMATION_NEW = "Missing Information New";
  static EPISODE_STATUS_GENERAL_ACTIVE = "General Active";
  static EPISODE_STATUS_DEVICE_NEEDED_ONHOLD = "Device Needed On Hold";
  static EPISODE_STATUS_OTHER_ONHOLD = "Other On Hold";
}

export class Withdrawing_Reasons {
  // Aligned with HP verbiage (WCP-13125). Alphabetized, "Other" kept last.
  // Mirrors the clinical_form_question_options reasons and api-common
  // WithdrawingReasons groupings.
  static EXCLUSION = [
    "Contract Terminated",
    "Did Not Consent",
    "Exclusion Criteria Met",
    "Health Issue/Death",
    "Hospice or End of Life Care",
    "Patient Not Suitable (lifestyle issue)",
    "Patient Thinks Too Healthy/Not Needed",
    "Payment/Insurance Related",
    "Plan Ineligible",
  ];
  static WITHDRAWL = [
    "Dissatisfaction with Services",
    "End of Trial Services",
    "Overwhelmed/Causes Anxiety",
    "Patient Does Not Want/Does Not See Benefit",
    "Patient Left Practice or Moved",
    "Provider Involved Decision",
    "Technical/Product Issue (Wifi)",
    "Unreachable",
    "Other",
  ];
}

type pathwayObject = {
  [key: string]: { color: string; title: string };
};
export class Pathway_Lookup {
  static pathwayValues: pathwayObject = {
    "b3c22e8d-1c27-4f2b-9197-f251d3a7514d": {
      color: "red",
      title: "High Risk",
    },
    "68ee10d8-d498-49a2-9324-8defe4a6471e": {
      color: "red",
      title: "High Risk",
    },
    "36128f0e-2419-4a70-a3fc-2d405ea8aef6": {
      color: "orange",
      title: "Medium Risk",
    },
    "e67eb0a4-e04d-4f6e-9841-67b559f764af": {
      color: "green",
      title: "Rising Risk",
    },
  };
}

export class External_Care_Team {
  static externalTeamLookups = {
    specialityId: "ac1ffcf9-a4c7-41ee-805d-ed0fbafb89d3",
    contactTypeId: "72b24435-ee0f-4cdb-a2dd-e595e24d84fa",
    phoneTypeId: "68eef144-7f93-418a-af5f-d2316ce5be9d",
  };
}

export const BILLING_MODELS = {
  VALUE_BASED_CARE: "VBC",
  FEE_FOR_SERVICE: "FFS",
};
